<template>
  <div class="layout-padding">

   <!-- <div class="lp-bg-table">
      <lp-input-text :data.sync="forms.name" label="메뉴명" inputWidth="380px" block="inline-block"></lp-input-text>
      <lp-input-text :data.sync="forms.path" label="링크주소" inputWidth="380px" block="inline-block"></lp-input-text>
      <div class="flex">
        <div style="color: #064160;font-size: 0.83rem;font-weight:600">부모 메뉴</div>
        <lp-sort-drop-down type="string" width="150" :list="typeOpts"
                           :data="getParent(forms.parent)"
                           @onSelect="res => forms.parent = res"
                           style="display:inline-block"></lp-sort-drop-down>
      </div>
      <div class="div-save">
        <div class="btn-save" @click="clearData">새로입력</div>
        <div class="btn-save" @click="saveData">저장하기</div>
      </div>
    </div>-->
    <div class="lp-bg-table">
      <table>
        <tr>
          <th>부모</th>
          <th>메뉴명</th>
          <th>주소</th>
          <th>활성화</th>
        </tr>

        <tr :key="'menu'+idx" v-for="(menu,idx) in menus">
          <!--<td>{{ getParent(bo.parent) }}</td>-->
          <td>{{ menu.parent }}</td>
          <td>{{ menu.name }}</td>
          <td>{{ menu.path }}</td>
          <td>
            <lp-range-bool :active="true" :val.sync="menu.enable" @update:val="res => onEnable(menu, res)"></lp-range-bool>
          </td>
          <td>
            <div class="btn-update" @click="clickItem(menu,'update')">수정</div>
            <div class="btn-delete" @click="clickItem(menu,'delete')">삭제</div>
          </td>
        </tr>

      </table>
    </div>
  </div>
</template>

<script>
  import LpInputText from "../../module/common/LpInputText"
  import LpSortDropDown from "../../module/common/LpSortDropDown"
  import LpRangeBool from "../../module/common/LpRangeBool";


  export default {
    components: {
      LpRangeBool,
      LpInputText, LpSortDropDown
    },
    created() {
      this.getData();
    },
    data() {
      return {
        menus: [],
        forms: {
          name: '',
          path: '',
          parent: ''
        },
        /*typeOpts: [
          { label: 'name', value: 'name' },
          { label: 'text', value: 'text' },
          { label: 'image', value: 'image' },
          { label: 'text', value: 'text' },
          { label: 'bool', value: 'bool' },
          { label: 'array', value: 'array' },
          { label: 'images', value: 'images' },
          { label: 'tags', value: 'tags' },
          { label: 'address', value: 'address' },
          { label: 'number', value: 'number' },
          { label: 'category', value: 'category' },
        ]*/
      }
    },
    methods: {
      getData() {
        this.$axios.get('menu/admin')
          .then(res => {
              if(res.status === 200) {
                this.menus = res.data;
              }
            }
          );
      },
      /*getParent(parent) {
        if(parent === '' || parent === null || parent === undefined) return '';
        let pa = find(this.typeOpts, 'value', parent);
        if(pa === undefined) return '';
        return find(this.typeOpts, 'value', parent).label;
      },*/
      clearData() {
        this.forms = {
          name: '',
          path: '',
          parent: ''
        };
      },
      saveData() {
        this.$axios.post('reg_menu', this.forms)
          .then(res => {
            if(res.data.result === 'ok') {
              this.toast('저장되었습니다.')
              this.getData();
            }
          });
      },
      onEnable(bo, res) {
        bo.enable = res;
        this.$axios.post('set_menu_enable', {
          id: bo.id,
          enable: res
        });
      },
      clickItem(bo, type) {
        if(type === 'delete') {
          this.$axios.post('del_menu', {
            id: bo.id
          }).then(res => {
            this.getData();
          });
        }
        else if(type === 'update') {
          this.forms = bo;
        }
      }
    }
  }
</script>

<style type="styl" lang="stylus" scoped>
  //@import '~assets/css/lp_main'

</style>
